/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Localcms_Read_Time_MinutesInputs */

const en_localcms_read_time_minutes = /** @type {(inputs: Localcms_Read_Time_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min read`)
};

/**
* | output |
* | --- |
* | "{minutes} min read" |
*
* @param {Localcms_Read_Time_MinutesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const localcms_read_time_minutes = /** @type {((inputs: Localcms_Read_Time_MinutesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Localcms_Read_Time_MinutesInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_localcms_read_time_minutes(inputs)
});